import React from 'react';
import { Tooltip, Fade } from '@mui/material';

import Stack from '@mui/material/Stack';
import { Button, Box, Typography, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
//import InsightsIcon from '@mui/icons-material/Insights';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
//import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
//import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';

//import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
//import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
//import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

//import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import { useSelector, useDispatch } from "react-redux";
import { breadcrumbsActions } from "../../_services/essentials/store";
import {history} from "../../_services/essentials/helpers";

export default function MenuContent({ isCollapsed }) {

    const accessTo = useSelector(x => x.auth.accessTo);
    const selectedMenuIndex = useSelector(x => x.breadcrumbs?.selected_menu_index);
    const dispatch = useDispatch();

    const mainListItems = [
        { text: 'Discovery', icon: <SearchIcon />, url: '/discovery/identified_profiles', visibility: accessTo.USER_AND_ABOVE },
        { text: 'Projects', icon: <FolderOpenIcon />, url: '/user_projects', visibility: accessTo.PROSPECT_AND_ABOVE },
        { text: 'Inquiry', icon: <QuestionAnswerIcon />, url: '/inquiry/add', visibility: accessTo.PROSPECT_AND_ABOVE },
        { text: 'My KOL/DOL', icon: <PeopleOutlineOutlinedIcon />, url: '/master_profiles', visibility: accessTo.PROSPECT_AND_ABOVE },
        // { text: 'DOL Dedicated', icon: <ViewListRoundedIcon />, url: '/dol_profiles/dol_dedicated', visibility: accessTo.PROSPECT_AND_ABOVE },
        // { text: 'Added Profiles', icon: <AssignmentRoundedIcon />, url: '/master_profiles', visibility: accessTo.PROSPECT_AND_ABOVE },
    ];

    const totalMainListItems = mainListItems.length;

    const adminListItems = [
        { text: 'Customers', icon: <CorporateFareIcon />, url: '/customers', visibility: accessTo.ADMIN_AND_ABOVE },
        { text: 'Users', icon: <PeopleRoundedIcon />, url: '/users', visibility: accessTo.ADMIN_AND_ABOVE },
    ];

    const secondaryListItems = [
//  { text: 'Help', icon: <HelpRoundedIcon />, url: '/reference_page' },
        //  { text: 'Reference Page', icon: <InfoRoundedIcon />, url:'/reference_page' },
        //  { text: 'Feedback', icon: <HelpRoundedIcon />, url:'/reference_page' },
    ];

    const fullMenuListItems = [mainListItems, adminListItems];

    function setSelectedMenuIndex(selectedMenuId) {
        dispatch(breadcrumbsActions.setSelectedMenuIndex(selectedMenuId));
    }

    function handleMenuClick(url, selectedMenuId) {
        setSelectedMenuIndex(selectedMenuId);
        history.navigate('/navigate', { state: {url: url}, replace:true});
    }

  return (
    <Stack sx={{ flexGrow: 1, p: 1 }}>
        <Box sx={{
            display: 'flex',
            width: '100vw',
        }}>
        <Box
            sx={{
//                width: drawerWidth,
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0
            }}
        >
            {/* Navigation Links */}

            {fullMenuListItems.map((menuList, mainIndex) => (
            <Stack spacing={0.5} sx={{ px: 0.5, py: 3 }}>
                {menuList.map((item, index) => (
                    item.visibility &&
                    isCollapsed ? (
                        <IconButton
                                sx={{
                                    justifyContent: 'flex-start',
                                    color: '#fff',
                                    bgcolor: selectedMenuIndex === (mainIndex+'.'+index) ? '#303f9f' : 'rgba(255,255,255,0.01)',
                                    textTransform: 'none',
                                    border: 0,
                                    pl:1,
                                    ml:1,
                                    width:  '100%',
                                    '&:hover': {
                                        backgroundColor: '#303f9f',
                                    },
                                }}
                                onClick={() => handleMenuClick(item.url, (mainIndex+'.'+index))}
                        >
                            {item.icon}
                        </IconButton>
                    ) : (
                        <Button startIcon={item.icon}
                                sx={{
                                    justifyContent: 'flex-start',
                                    color: '#fff',
                                    bgcolor: selectedMenuIndex === (mainIndex+'.'+index) ? '#303f9f' : 'rgba(255,255,255,0.01)',
                                    textTransform: 'none',
                                    borderRadius: 1,
                                    pl:1,
                                    ml:1,
                                    width:  '100%'
                                }}
                                onClick={() => handleMenuClick(item.url, (mainIndex+'.'+index))}
                        >
                            { item.text }
                        </Button>
                    )
                ))}
            </Stack>
            ))}
        </Box>
        </Box>
    </Stack>
  );
}
